import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { authenticationService } from '@enkla-gui'

/**
 * Token-based login page for admin impersonation.
 * Accepts a token via URL query parameter and logs the user in automatically.
 *
 * Usage: /token-login?token=BASE64_ENCODED_TOKEN
 */
export default function TokenLogin() {
  const location = useLocation()
  const history = useHistory()
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Extract token from query parameter
    const params = new URLSearchParams(location.search)
    const tokenParam = params.get('token')

    if (!tokenParam) {
      setError('No token provided')
      setLoading(false)
      return
    }

    try {
      // Parse the token data (it's base64 encoded JSON)
      const tokenData = JSON.parse(atob(tokenParam))

      if (!tokenData.access_token) {
        setError('Invalid token format')
        setLoading(false)
        return
      }

      // Use the auth service to properly set the token (updates BehaviorSubject)
      authenticationService.loginWithToken(tokenData)

      // Navigate to dashboard using history (works with HashRouter)
      history.push('/dashboard')
    } catch (e) {
      console.error('Token login error:', e)
      setError('Invalid token')
      setLoading(false)
    }
  }, [location, history])

  if (loading) {
    return (
      <div className='full-height login-wrapper'>
        <div className='col bicflex'>
          <div className='user-form text-center'>
            <h4>Loggar in...</h4>
            <p className='text-muted'>Vänta medan vi loggar in dig automatiskt.</p>
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className='full-height login-wrapper'>
        <div className='col bicflex'>
          <div className='user-form text-center'>
            <h4 className='text-danger'>Inloggning misslyckades</h4>
            <p className='text-muted'>{error}</p>
            <a href='#!/login' className='btn btn-primary mt-3'>
              Gå till inloggning
            </a>
          </div>
        </div>
      </div>
    )
  }

  return null
}
